import React, { useState } from "react";
import { Box } from "@mui/material";
import { Add } from "@mui/icons-material";

import { PageLayout } from "../../layouts/PageLayout";
import { PageHeader } from "../../components/v3";
import { AddPerformanceGuarantees, PerformanceGuaranteesList } from "../../components/performanceGuarantee";
import { useHasPermission } from "../../utils";
import { CREATE_PERFORMANCE_GUARANTEE } from "../../constants";

export const PerformanceGuarantees = () => {
  const [totalCount, setTotalCount] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [reload, setReload] = useState(0);

  const hasCreatePerformanceGuarantee = useHasPermission(CREATE_PERFORMANCE_GUARANTEE);

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const handleReload = () => setReload((prev) => prev + 1);

  const buttons = [hasCreatePerformanceGuarantee && { buttonText: "Add PG & AD PG", buttonIcon: Add, onClick: handleOpenModal }];

  return (
    <>
      <PageLayout>
        {/* header section */}
        <Box sx={{ position: "relative", zIndex: 1 }}>
          <PageHeader title="PG & AD PG" buttons={buttons} />
        </Box>

        {/* table section */}
        <Box sx={{ mt: -9, zIndex: 2, position: "relative" }}>
          <PerformanceGuaranteesList totalCount={totalCount} setTotalCount={setTotalCount} reloadData={reload} />
        </Box>
      </PageLayout>

      {/* add pg and ad pg modal */}
      <AddPerformanceGuarantees open={openModal} onClose={handleCloseModal} onSuccess={handleReload} />
    </>
  );
};
